/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.error\":[\"Åttekant med utropstegn\"]}");